module.exports = __webpack_public_path__ + "a25aad5c4c3ddc17a8f4209907244c99.png";